export default "__VITE_ASSET__4a1e2b82__"